/**
 * @module cercaliagl/proj
 */

/**
 * Projections
 * @enum {string}
 */
export default {
  EPSG4326: 'EPSG:4326',
  EPSG3857: 'EPSG:3857',
};
